import { useCallback, useEffect, type ReactNode } from 'react'
import { setFormatLocale } from '../lib/format'
import { useAuthStore } from '../stores/auth'
import { useUiStore } from '../stores/ui'
import { I18nContext } from './context'
import { translate, type DictPath } from './translate'

export function I18nProvider({ children }: { children: ReactNode }) {
    const language = useUiStore(s => s.language)
    const user = useAuthStore(s => s.user)
    const adoptProfileLanguage = useUiStore(s => s.adoptProfileLanguage)

    // Profil-Sprache nach Login/Session-Restore übernehmen — aber nur,
    // solange der Nutzer hier im Browser nie selbst umgeschaltet hat.
    useEffect(() => {
        if (user) adoptProfileLanguage(user.userLanguage)
    }, [user, adoptProfileLanguage])

    // Locale-Formatter (Geld/Datum) + Dokument-Meta mit der Sprache synchron halten
    useEffect(() => {
        setFormatLocale(language)
        document.documentElement.lang = language
        document.title = translate(language, 'app.title')
    }, [language])

    const t = useCallback(
        (key: DictPath, params?: Record<string, string | number>) =>
            translate(language, key, params),
        [language],
    )

    return <I18nContext.Provider value={t}>{children}</I18nContext.Provider>
}
